import { IDotsButtonProps } from "dots-ui/dotsButton";
import { AvisButton } from "./AvisButton";

export function AvisPrimaryButton(props: Readonly<IDotsButtonProps>) {
  return <AvisButton severity="primary" variant="filled" {...props} />;
}
